module.exports = __webpack_public_path__ + "img/01_bg.68a6c8c8.png";